import { z } from "zod"
import { isValidEthereumAddress, isValidSolanaAddress } from "@/lib/web3"

export const formSchema = z
  .object({
    address: z.string().optional(),
    wallet: z
      .object({
        ethAddress: z.string(),
        solAddress: z.string(),
      })
      .optional(),
  })
  .refine(
    (data) => {
      return (
        data.wallet ||
        (data.address &&
          (isValidEthereumAddress(data.address) ||
            isValidSolanaAddress(data.address)))
      )
    },
    {
      // This message will be shown if the refine function returns false
      message: "Invalid address",
      path: ["address"], // This specifies that the error should be associated with the 'address' field
    },
  )
